import React from 'react';

const About = () => {
  return (
    <div className='jumbotron jumbotron-fluid'>
      <div className='container'>
        <h1 className='display-4'>Information</h1>
        <p className='lead'>This is a test project didicated to React Hooks.</p>
        <p className='lead'>
          Using this App you can find users from github and check out their bio,
          repos and other info
        </p>
      </div>
    </div>
  );
};

export default About;
